<template>
  <div class="modal fade" id="AddMotifSuiviModal" tabindex="-1" role="dialog" ref="addMotifSuiviModalRef" aria-labelledby="tooltipmodal" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">{{ title }}</h4>
                <button class="btn-close py-0" type="button" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
          <Form ref="motifSuiviForm" @submit="addMotifSuivi" :validation-schema="motifSuiviSchema">
            <div class="row">
              
            <div class="col-md-12 mb-3">
              <div class="form-group mb-15 mb-sm-20 mb-md-25">
                <label class="d-block text-black fw-semibold mb-10" >
                  Libelle <span class="text-danger">*</span>
                </label>
                <Field name="libelle" type="text" 
                class="form-control shadow-none fs-md-15 text-black" placeholder="Entrer le libelle"/>
                <ErrorMessage name="libelle" class="text-danger"/>
              </div>
            </div>
            <button  ref="submitButton"
              class="btn btn-primary"
              type="submit"
            >
            {{ btntext }}
            </button>
      </div>
        </Form>
        </div>
        <!-- <button
          type="button"
          class="btn-close shadow-none"
          data-bs-dismiss="modal"
          aria-label="Close"
          @click="resetValue()"
        ></button> -->
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, watch } from 'vue';
import { Form, Field, ErrorMessage } from 'vee-validate';
import ApiService from '@/services/ApiService';
import * as Yup from 'yup';
import { hideModal } from '@/utils/utils';
import { MotifSuivi } from '@/models/MotifSuivi';
import { error , success } from '@/utils/utils';
import { useRouter } from 'vue-router';
import Multiselect from '@vueform/multiselect'
import axios from 'axios';


export default defineComponent({
    name: "AddMotifSuiviModal",
    components: {
    Form,
    Field,
    ErrorMessage,
    Multiselect
  },
  props: {
    item: {
      type: Number,
      default: 0,
    }
  },
  setup(props, { emit }){
    const motifSuiviSchema = Yup.object().shape({
      libelle: Yup.string().required('Le libelle est obligatoire'),
     

    });

    const motifSuiviForm = ref<MotifSuivi | null>(null);
    const addMotifSuiviModalRef = ref<null | HTMLElement>(null);
    const submitButton = ref<HTMLButtonElement | null>(null);
    const router = useRouter();
    // const item = ref({ ...props.item });
    const localItem = ref(props.item);
    const isUPDATE = ref(false);
    const title = ref("Ajouter un motif suivi");
    const btntext = ref('Ajouter');
    // const produitOptions = ref([]);

    watch(() => props.item, (newValue) => {
      getMotifSuivi(newValue);
      isUPDATE.value = true;
      btnTitle();
    });

    const btnTitle = async () => {
      if (isUPDATE.value) {
         title.value = "Modifier le motif suivi";
         btntext.value = "Modifier";
      }else{
         title.value = "Ajouter un motif suivi";
         btntext.value = "Ajouter"
      }
    }

    const getMotifSuivi = async (id: number) => {
      return ApiService.get("/motifSuivis/"+id)
      .then(({ data }) => {
        // map data in form
        const donnees = data.data;
        for (const key in donnees) {
          motifSuiviForm.value?.setFieldValue(key, 
          (typeof donnees[key] === 'object' && donnees[key] !== null)? donnees[key].id :donnees[key]
          );
        }
        emit('openmodal', addMotifSuiviModalRef.value);

      })
      .catch(({ response }) => {
        error(response.data.message)
      });
    }


    

    const addMotifSuivi = async (values: any, motifSuiviForm) => {
      if (submitButton.value) {
        // eslint-disable-next-line
        submitButton.value.disabled = true;
      }

      values = values as MotifSuivi;
      if(isUPDATE.value){
        ApiService.put("/motifSuivis/"+values.id,values)
        .then(({ data }) => {
            if(data.code == 200) { 
              success(data.message);
              motifSuiviForm.resetForm();
              hideModal(addMotifSuiviModalRef.value);
              isUPDATE.value=false;
              btnTitle();
              emit('close');
            }
        })
        .catch(({ response }) => {
            error(response.data.message);
        });
      }else{
        console.log('values',values)
        ApiService.post("/motifSuivis",values)
        .then(({ data }) => {
            if(data.code == 201) { 
              success(data.message);
              motifSuiviForm.resetForm();
              hideModal(addMotifSuiviModalRef.value);
              emit('close');
            }
        })
        .catch(({ response }) => {
          submitButton.value!.disabled = false;
            error(response.data.message);
        });
      }
    };

    const resetValue = () => {
      const formFields = document.querySelectorAll<HTMLInputElement | HTMLTextAreaElement>('input, textarea');
        isUPDATE.value=false;
      formFields.forEach(field => {
        field.value = '';
      });
      btnTitle()
    };

    return { motifSuiviSchema,
      addMotifSuiviModalRef,
      submitButton,
      addMotifSuivi,
      motifSuiviForm,
      title,btntext,resetValue
    };
  },
});
</script>@/models/CategorieInfo